module.exports = function getResource(label) {
    const resources = {
        anErrorOccurredPleaseTryAgainLater: 'Something went wrong. Please try again.',
        error: 'Error',
        ok: 'OK',
        passkeyAuthenticationErrorMessage: 'An error occurred while signing you in. Please use your email and password to sign in.',
        passkeyAccountDeactivatedMessage: 'To reactivate the account, please call our Customer Service team at 1-877-SEPHORA (1-877-737-4672) Or Chat with our agents.',
        passkeyFromYourAccount: 'passkey from your account.',
        passkeyRemoved: 'Passkey Removed',
        pleaseConfirmYouWantToRemove: 'Please confirm you want to remove',
        removePasskey: 'Remove Passkey',
        removePasskeysTitle: 'Remove Passkey?',
        yourPasskeyHaveBeenRemoved: 'Your passkey has been removed.',
        passkeyLoginError: 'We’re unable to complete your sign‑in right now. Please try again.'
    };
    return resources[label];
};
